module.exports = __webpack_public_path__ + "34b0a3876852aab3dbc020a3b9351a95.png";